import React from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider, CssBaseline, createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';

import PageHeaderSection from './pageHeaderSection';
import MountainInfoSection from './mountainInfoSection';
import CombinedBarSection from './combinedBarSection';
import DiamondInfoSection from './diamondInfoSection';

import './main.css';
import hyblockVideo from './images/HyblockCapital.webm';
import zlVsWalkmeVideo from './images/ZL vs. WalkMe.m4v';
import graphic from './images/zip-editor.png';
import useMediaQuery from "@material-ui/core/useMediaQuery";

function Ziplyne_walkme() {
    // Custom Material UI theme
    const theme = responsiveFontSizes(createMuiTheme({
        typography: {
            fontFamily: 'Lato, Roboto, sans-serif'
        },
        palette: {
            background: {
                default: '#fff'
            }
        }
    }));

    const screenIsSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Helmet>
                <title>Ziplyne vs Walkme</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <CssBaseline>
                    <ParallaxProvider>
                        <main>
                            <Parallax y={[-15, 15]}>
                                <PageHeaderSection>
                                    Why Walk When You Can <b>Zip?</b>
                                </PageHeaderSection>
                            </Parallax>
                            <MountainInfoSection
                                content={"At Ziplyne, we understand that Digital Adoption is just the beginning, which is why we’ve designed a product that seamlessly aligns Support, Onboarding, Adoption and Retention so that you can SOAR!"}
                                media={hyblockVideo}
                                hideParallax={screenIsSmall}
                            />
                            <CombinedBarSection
                                header={"We Listened...\nWe Built"}
                                content={"Ziplyne is designed to be easy to use and non-intrusive, and absolutely NO CODING is necessary for content creation."}
                                image={graphic}
                                videoHeader={"But don’t just take our word for it... Compare for yourself!"}
                                hideParallax={screenIsSmall}
                            />
                            <DiamondInfoSection
                                content={"And best of all, Ziplyne’s ease of use unlocks multiple new paths of value and productivity including lower TCO and greater scalability!"}
                                video={zlVsWalkmeVideo}
                            />
                        </main>
                    </ParallaxProvider>
                </CssBaseline>
            </ThemeProvider>
        </>
    )
        ;
}

export default Ziplyne_walkme;
